import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import { useState } from "react";
import PropTypes from "prop-types";
import { ResponsiveRow } from "../../constants/layout.constants";

FileUpload.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  accept: PropTypes.string,
  required: PropTypes.bool,
  // progress:PropTypes.number
};

//TODO: Add in support for multiple files
// and implement progress

//TODO: validation for filetype based on accept
// value passed in

/**
 * Utility file upload component for now progress is turned off
 * @param props
 * @constructor
 */
export function FileUpload(props) {
  const [currentFile] = useState(props.currentFile);
  // const [progress] = useState(props.progress)

  const labelId = `${props.id}-label`;

  return (
    <ResponsiveRow
      component={FormControl}
      sx={{ width: "100%", padding: 0, height: "auto" }}
    >
      {props.label && props.required && (
        <InputLabel 
          id={labelId} 
          required 
          sx={{ 
            position: "relative",
            transform: "none",
            marginBottom: "8px"
          }}
        >
          {props.label}
        </InputLabel>
      )}
      {currentFile && <div className="file-name">{currentFile.name}</div>}
      {
      !currentFile && (
        <OutlinedInput
          labelId={props.label && props.required ? labelId : undefined}
          type={"file"}
          title={props.label}
          name={props.id}
          id={props.id}
          inputProps={{ accept: props.accept }}
          onChange={props.onChange}
          accept={props.accept}
          label={props.label && !props.required ? props.label : undefined}
          sx={{
            backgroundColor: props.bg_color ? props.bg_color : "transparent",
            fontSize: "14px",
            width: { xs: "100%", lg: props.width ? props.width : "90%" },
          }}
        />
      )
      }
    </ResponsiveRow>
  );
}
